import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import API from "../../helper/AxiosInterceptor";

const DashboardHeader = ({ appId }) => {
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);
  const isTestnet = process.env.REACT_APP_NETWORK_MODE === 'testnet';

  useEffect(() => {
    const fetchUnreadCount = async () => {
      try {
        const response = await API.get(
          `${process.env.REACT_APP_API_URL}/apps/unread-notification-count`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (response?.data?.count !== undefined) {
          setUnreadCount(response.data.count);
        }
      } catch (error) {
        console.error("Error fetching unread notification count:", error);
      }
    };

    fetchUnreadCount();
  }, []);

  const getTitle = (appId) => {


    switch (location.pathname) {
      case "/dashboard":
        return "Dashboard";
      case "/apps":
        return "Apps";
      case "/transactions":
        return "Payment Links";
      case "/customer-support":
        return "Customer Support";
      case "/my-profile":
        return "My Profile";
      case "/change-password":
        return "Change Password";
      case "/apps-transfer-history":
        return "Apps";
      case "/apps-payment-links":
        return "Apps";
      case "/apps-wallet-transactions":
        return "Apps";
      case "/apps-detail":
        return "Apps";
      case "/apps-send-withdraw":
        return "Apps";
      case "/apps-deposit-receive":
        return "Apps";
      case `/apps-detail/${appId}`:
        return "Apps";
      case "/settings":
        return "My Settings";
      case `/apps-payment-links/${appId}`:
        return "Payment Links";
      case `/apps-wallet-transactions/${appId}`:
        return "Wallet Transaction";
      case "/withdraw-invoice":
        return "Withdraw Invoice";
      default:
        return "Dashboard";
    }
  };
  return (
    <>
      <header className="dashboard-header">
        {isTestnet && (
          <div style={{
            background: 'rgba(255, 223, 100, 0.85)',
            backdropFilter: 'blur(4px)',
            color: '#000',
            textAlign: 'center',
            padding: '8px',
            fontSize: '14px',
            fontWeight: 'bold',
            width: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 9999,
            borderBottom: '1px solid rgba(224, 168, 0, 0.5)'
          }}>
            ⚠️ SANDBOX MODE: You are currently testing with simulated funds. Do not process real transactions here.
          </div>
        )}
        <div className="header-inner" style={isTestnet ? { paddingTop: '35px' } : {}}>
          <div className="dashboard-header-left">
            <button className="menu-toggal">
              <img src="images/menu-line.svg" alt="menu" />
            </button>
            <div className="logo">
              <a>
                <img src="images/logo.png" alt="logo" />
              </a>
            </div>
            <h2>{getTitle(appId)}</h2>
          </div>
          <div
            className="dashboard-header-right"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "1rem",
              cursor: "pointer",
              // color: "#666666",
            }}
          >
            <Link 
              to="/apis" 
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                color: "#111",
                fontWeight: "700",
                fontSize: "14px",
                textDecoration: "none",
                padding: "8px 16px",
                borderRadius: "8px",
                background: "linear-gradient(90deg, #FAD961 0%, #F76B1C 100%)", /* A premium vibrant gradient often used with crypto gold themes, or a solid gold */
                backgroundImage: "linear-gradient(90deg, rgb(245, 192, 5) 0%, rgb(245, 211, 5) 100%)",
                boxShadow: "0 4px 12px rgba(245, 192, 5, 0.3)",
                border: "1px solid rgba(245, 192, 5, 0.8)",
                marginRight: "10px",
                transition: "transform 0.2s ease"
              }}
              onMouseEnter={(e) => Object.assign(e.currentTarget.style, { transform: 'translateY(-2px)', boxShadow: "0 6px 15px rgba(245, 192, 5, 0.4)" })}
              onMouseLeave={(e) => Object.assign(e.currentTarget.style, { transform: 'translateY(0)', boxShadow: "0 4px 12px rgba(245, 192, 5, 0.3)" })}
            >
              <i className="ti ti-file-code" style={{ fontSize: "18px" }} />
              <span className="d-none d-md-inline">API Docs</span>
            </Link>

            <figure style={{ position: "relative", margin: 0 }}>
              <Link to="/notifications" style={{ position: "relative", display: "inline-block" }}>
                <img
                  src="images/bell-icon-transparent-notification-free-png.webp"
                  alt="notification icon"
                  style={{ display: "block" }}
                />
              </Link>
              {unreadCount > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    backgroundColor: "#ff4444",
                    color: "white",
                    borderRadius: "50%",
                    minWidth: "20px",
                    height: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "11px",
                    fontWeight: "bold",
                    padding: "0 4px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    zIndex: 10,
                  }}
                >
                  {unreadCount > 99 ? "99+" : unreadCount}
                </span>
              )}
            </figure>

            <figure>
              <Link to="/my-profile">
                <img src="images/user-profile.png" alt="user profile" />
              </Link>
            </figure>
          </div>
        </div>
      </header>
    </>
  );
};

export default DashboardHeader;
